// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8o-3";
export var contentContainer = "_8o-0";
export var editorContainer = "_8o-1";
export var quillInputForm = "_8o-2";
export var zoneDivider = "_8o-4";